import React, { useState } from 'react';
import classes from "./AboutSection.module.css";
import { Col, Container, Row, Modal } from 'react-bootstrap';
import Image from "../../assets/images/about.png";
import Button from "../../components/Button";

export default function AboutSection() {
  const [showModal, setShowModal] = useState(false);

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);

  return (
    <Container>
      <Row className={`gy-3 ${classes.rowClass}`}>
        <Col lg={6} md={12} sm={12}>
          <img src={Image} alt="img" className={classes.image} />
        </Col>
        <Col lg={6} md={12} sm={12}>
          <p className={`f-30 fw-400`}>About Us</p>
          <p className={`mt-2 f-45 fw-600 ${classes.heading}`}>
            Trusted Regulatory <span className='highlightedText'>Support</span> for Tribal <span className='highlightedText'>Enterprises.</span>
          </p>
          <p className={`f-16 fw-400 ${classes.aboutContent}`}>
            Tribal Regulatory Services (Tribal Reg) is a tribal regulatory services company for tribally owned consumer lending and e-commerce businesses...
          </p>

          <div className={classes.btnDiv}>
            <Button
              label={"learn more"}
              variant={"primary"}
              className={classes.btnClass}
              onClick={handleModalOpen}
            />
            <Button
              label={"contact us"}
              variant={"outlined"}
              onClick={() => handleScroll("contact")}
            />
          </div>
        </Col>
      </Row>

      {/* Modal */}
      <Modal show={showModal} onHide={handleModalClose} size="lg" centered>
        <Modal.Body style={{ padding: '2rem' }}>
          <h4 className="f-30 fw-600 mb-4">More About Tribal Regulatory Services</h4>

          <p className="f-18 fw-400 mb-3">
            Tribal Regulatory Services (Tribal Reg.) is a dedicated organization committed to upholding the sovereignty and self-governance of tribal nations through effective regulation and oversight. With a mission to safeguard tribal interests and promote sustainable growth, Tribal Reg. plays a pivotal role in ensuring compliance, consumer protection, and the development of tribal enterprises.
          </p>

          <p className="f-18 fw-400 mb-3">
            Tribal Reg. specializes in licensing, regulating, and supervising businesses and entities operating within tribal jurisdictions. By conducting thorough audits, investigations, and on-site examinations, we ensure adherence to applicable laws, regulations, and policies. This rigorous oversight fosters transparency, accountability, and ethical practices among service providers.
          </p>

          <p className="f-18 fw-400 mb-3">
            A cornerstone of Tribal Reg.'s operations is its focus on consumer protection. The organization provides a fair and impartial platform for addressing consumer complaints and resolving disputes. Through our regulatory framework, we ensure that financial services are extended to consumers on equitable terms, in compliance with all relevant consumer protection laws.
          </p>

          <p className="f-18 fw-400 mb-3">
            In addition to its regulatory functions, we actively support the growth of tribal businesses. By fostering a safe and sound business environment, we help contribute to the economic development and well-being of tribal communities. Tribal Reg.’s efforts are always aligned with the broader goal of preserving tribal sovereignty while promoting innovation and sustainability.
          </p>

          <p className="f-18 fw-400">
            Tribal Regulatory Services stands as a trusted partner for tribal nations, businesses, and consumers alike. Its unwavering commitment to excellence and integrity underscores its vital role in advancing the interests of tribal communities and ensuring a prosperous future.
          </p>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none', justifyContent: 'center' }}>
          <Button label="Close" variant="outlined" onClick={handleModalClose} />
        </Modal.Footer>
      </Modal>
    </Container>
  );
}
